import React, { useEffect } from "react";
import styled from "styled-components"

import Layout from "../components/layout"
import Container from "../components/container"
import PageHeader from "../components/header-page"

import ReactGA from "react-ga4";
ReactGA.initialize("G-THHYTX4Y9V");

const Content = styled.div`
  padding-bottom: 75px;
  
  p:nth-child(1) {
    margin-top: 0px;
  }
`

function PhilharmonicPage(props) {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/philharmonic", title: "Philharmonic Club"});
  }, []);

  return (
    <Layout page="philharmonic" title="Philharmonic Club">
      <Container>        
        <PageHeader>Philharmonic Club</PageHeader>
      </Container>        
      <Container>        
        <Content>
          <p>
            Supporters of the Marshall Artists Series are important to its consistent success. The 
            Philharmonic Club is the Artists Series' oldest form of private support. The cost of 
            producing the arts is expensive. Talent costs as well as equipment rentals and 
            production costs continue to increase while ticket prices have remained the same.
          </p>
          <p>
            The Marshall Artists Series must receive 75% of its funding from the community. Therefore, 
            contributions to the Philharmonic Club are an essential part of our funding and we thank 
            you for your contributions.
          </p>

          <h3>The Benefits</h3>

          <ul>
            <li>Preferential seating based upon availability</li>
            <li>Invitations to post-performance parties, often attended by the performers</li>
            <li>Names imprinted in all show programs (optional)</li>
            <li>Post show receptions at area businesses</li>
          </ul>

          <h3>Levels of Giving</h3>

          <ul>
            <li>Leaders ($1,000 +)</li>
            <li>Benefactors ($500-$999)</li>
            <li>Patrons ($250 - $499)</li>
            <li>Friends ($200 - $249)</li>
          </ul>

          <p>
            For more information please call us at 304.696.3326 
          </p>
        </Content>
      </Container>
    </Layout>
  );
}

export default PhilharmonicPage;